// Node imports
import { Container, delayedCall, dispatcher, ingenuity, killDelayedCall, Label, Linear, SpineBase } from "@quest/base-core";
import {
  IntroOutroControllerBehavior,
  MeterBehavior,
  SlotAnimationConstant,
  SlotConstantsBehavior,
  SlotEventConstantsBehavior,
  SoundConstant,
} from "@quest/murka-games-behavior-panther/dist/";
import { GameParserModel } from "../Platform/GameParserModel";
import { SlotEventConstants } from "@quest/slot-core";
import { spineConstants } from "../Constants/gameConstants";
import { eventDispatchers } from "../Constants/EventDispatchers";
// import { constants } from "@quest/base-core/dist/detectDeviceEnvironment/Constants";

export class IntroOutroControllerGame extends IntroOutroControllerBehavior {
  private OUTRO_IN_FG: string = "freespin_outro_in";
  private OUTRO_LOOP_FG: string = "freespin_outro_loop";
  private OUTRO_OUT_FG: string = "freespin_outro_out";

  private INTRO_OUTRO_RAYS: string = "freespin_in_effect";
  private freegameIntroBackgroundLayer: SpineBase;
  private freegameOutroBackgroundLayer: SpineBase;
  private freegameIntroBackgroundLayerPortrait: SpineBase;
  private freegameOutroBackgroundLayerPortrait: SpineBase;

  private introRaysAnim: SpineBase;

  private introPopupBG: any;
  private continueText: Label;

  private outroPopupBG: any;
  private outroContinueText: Container;

  /**
   * Method overrided to initialize spine by IDs.
   */
  protected initializeElements(): void {
    this.outroImg = this.view.getImageById("FGOutroImage");
    this.fadeContainer = this.view.getContainerByID("fadeContainer");
    this.msgWindowBorderAnim = this.view.getAnimationById("MssgWindow_Border_Animation");
    this.msgWindow = this.view.getImageById("MssgWindow");
    this.introShapeBG = this.view.getShapeById("introShapeBG");
    this.freeGameWins = this.view.getContainerByID("freeGameWinsCont");
    this.freeGameCompleteCont = this.view.getContainerByID("freeGameCompleteCont");
    this.OutroWinAmount = this.view.getMeterById("OutroWinAmount") as MeterBehavior;
    this.outroWinAmount = 0;
    this.fgIntroSpineMainContainer = this.view.getContainerByID("fgIntroSpineMainContainer");
    this.fgOutroSpineContainer = this.view.getContainerByID("fgOutroSpineContainer");
    this.fgOutroSpine = this.view.getSpineById("freegameOutroBackground");
    !ingenuity.deviceEnv.isDesktop && this.initializePortraitComponent();
    this.freeGameIntroSpine = this.view.getSpineById("freegameIntroBackground");
    this.introRaysAnim = this.view.getSpineById("freegameIntroBackgroundRays");
    this.introTextSpine = this.view.getSpineById("freegameIntro");
    this.outroTextSpine = this.view.getSpineById("freegameOutro");
    this.view.mask = this.view.getShapeById("introOutroMask");

    this.introPopupBG = this.view.getShapeById("introPopupBG");
    this.continueText = this.view.getLabelById("continueText") as Label;
    this.outroPopupBG = this.view.getShapeById("outroPopupBG");
    this.outroContinueText = this.view.getContainerByID("continueTextContainer") as Label;
    this.textAndNumberContainer = this.view.getContainerByID("introTextAndNumberContainer");
    this.totalSpinTriggered = this.view.getMeterById("totalIntroSpins") as MeterBehavior;
    this.freegameIntroBackgroundLayer = this.view.getSpineById('freegameIntroBackgroundLayer');
    this.freegameOutroBackgroundLayer = this.view.getSpineById('freegameOutroBackgroundLayer');
  }

  protected initializePortraitComponent(): void {
    super.initializePortraitComponent();
    this.freegameIntroBackgroundLayerPortrait = this.view.getSpineById('freegameIntroBackgroundLayerPortrait');
    this.freegameOutroBackgroundLayerPortrait = this.view.getSpineById('freegameOutroBackgroundLayerPortrait');
  }
  protected onIntroShow(): void {
    this.totalSpinTriggered.setText(String((ingenuity.parserModel as GameParserModel).getFreeSpinNum()));
    ingenuity.configData.showBaseGameScreen = true;
    dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_POST_LOADER);
    dispatcher.fireEvent(SlotEventConstantsBehavior.STOP_GAME_SOUND, { id: SoundConstant.MUSIC_SPIN });
    ingenuity.configData.isReelSpinMusicPlaying = false;

    // super.onIntroShow();
    ingenuity.configData.showBaseGameScreen = true;
    dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_POST_LOADER);
    dispatcher.fireEvent(SlotEventConstantsBehavior.STOP_GAME_SOUND, { id: SoundConstant.MUSIC_SPIN });
    ingenuity.configData.isReelSpinMusicPlaying = false;

    this.IntroOutroContainer && (this.IntroOutroContainer.visible = true);
    this.IntroContainer && (this.IntroContainer.visible = true);
    this.OutroContainer && (this.OutroContainer.visible = false);
    ingenuity.currentGame.stage.addChild(this.view);

    this.IntroOutroContainer && (this.IntroOutroContainer.visible = true);
    dispatcher.fireEvent(SlotEventConstantsBehavior.SUSPEND_WIN_PRESENTATION);
    // Neeed to call again Since when Freegame trigger second time all instance are lost and `initializeElements` called in constructor only
    this.initializeElements();
    this.OutroContainer.visible = false;
    this.introShowDelay();
    (ingenuity.parserModel as GameParserModel).getPromotionalFreeGame() &&
      dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_HIDE_PROMOTIONAL_FREE_PLAY, false);
    this.IntroOutroContainer && (this.IntroOutroContainer.visible = true);
    dispatcher.fireEvent(SlotEventConstantsBehavior.SUSPEND_WIN_PRESENTATION);
    // Neeed to call again Since when Freegame trigger second time all instance are lost and `initializeElements` called in constructor only
    this.initializeElements();
    this.OutroContainer.visible = false;
    this.introShowDelay();
    (ingenuity.parserModel as GameParserModel).getPromotionalFreeGame() &&
      dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_HIDE_PROMOTIONAL_FREE_PLAY, false);
  }

  protected playfgIntroBgSpine(): void {
    this.freeGameIntroSpine.visible = true;
    this.freegameIntroBackgroundLayer.visible = true;
    this.playIntroRaysInAnim();
    this.freeGameIntroSpine.playAnim(SlotAnimationConstant.FG_INTRO_DESKTOP_BG_IN, false);
    this.freegameIntroBackgroundLayer.playAnim(spineConstants.FG_INTRO_DESKTOP_LAYER_BG_IN, false);
    this.freeGameIntroSpine.onComplete.addOnce(() => {
      this.freeGameIntroSpine.playAnim(SlotAnimationConstant.FG_INTRO_DESKTOP_BG_STATIC, true);
      this.freegameIntroBackgroundLayer.playAnim(spineConstants.FG_INTRO_DESKTOP_LAYER_BG_STATIC, false);
    }, this);
  }

  protected playFgIntroPortraitBgSpine(): void {
    this.freeGameIntroPortraitSpine.setPause(false);
    this.freegameIntroBackgroundLayerPortrait.setPause(false);
    this.freeGameIntroPortraitSpine.visible = true;
    this.freegameIntroBackgroundLayerPortrait.visible = true;
    this.freeGameIntroPortraitSpine.playAnim(SlotAnimationConstant.FG_INTRO_PORTRAIT_BG_IN, false);
    this.freegameIntroBackgroundLayerPortrait.playAnim(spineConstants.FG_INTRO_LAYER_BG_IN_PORTRAIT, false);
    this.freeGameIntroPortraitSpine.onComplete.addOnce(() => {
      this.freeGameIntroPortraitSpine.playAnim(SlotAnimationConstant.FG_INTRO_PORTRAIT_BG_STATIC, true);
      this.freegameIntroBackgroundLayerPortrait.playAnim(spineConstants.FG_INTRO_LAYER_BG_STATIC_PORTRAIT, false);
    }, this);
  }

  /**
    * This method do functionality after intro spine end play in portrait
    */
  onPortraitIntroSpinEnds() {
    this.freeGameIntroPortraitSpine.playAnim(SlotAnimationConstant.FG_INTRO_PORTRAIT_BG_OUT, false);
    this.freegameIntroBackgroundLayer.playAnim(spineConstants.FG_INTRO_LAYER_BG_OUT_PORTRAIT, false);
    this.freeGameIntroPortraitSpine.onComplete.addOnce(() => {
      this.freegameIntroBackgroundLayer.visible = false;
      this.freegameIntroBackgroundLayer.setPause(true);
      this.freeGameIntroPortraitSpine.visible = false;
      this.freeGameIntroPortraitSpine.setPause(true);
      this.freeGameIntroPortraitSpine.onComplete.dispose();
    }, this);
    this.introTextSpinePort.playAnim(SlotAnimationConstant.FG_INTRO_PORTRAIT_OUT, false);
    this.introTextSpinePort.onComplete.addOnce(() => {
      this.introTextSpinePort.visible = false;
      this.introTextSpinePort.setPause(true);
      this.introTextSpinePort.onComplete.dispose();
    }, this);
  }

  protected playfgIntroTextSpine(): void {
    dispatcher.fireEvent(eventDispatchers.RESET_FS_BAR);
    this.introTextSpine.setPause(false);
    this.introTextSpine.visible = true;
    this.introTextSpine.playAnim(SlotAnimationConstant.FG_INTRO_DESKTOP_IN, false);
    this.introTextSpine.onComplete.addOnce(() => {
      this.introTextSpine.playAnim(SlotAnimationConstant.FG_INTRO_DESKTOP_STATIC, true);
      this.onStageClick();
    }, this);
  }

  private playIntroRaysInAnim(): void {
    this.introRaysAnim.visible = true;
    this.introRaysAnim.playAnim(this.INTRO_OUTRO_RAYS, false);
    this.introRaysAnim.onComplete.addOnce(() => {
      this.introRaysAnim.visible = false;
    }, this);
  }

  protected onIntroHide(): void {
    //
  }

  protected onContinuePressUP(): void {
    this.playDektopIntroOutAnim();
    !ingenuity.deviceEnv.isDesktop && this.onPortraitIntroSpinEnds();
    this.hideTextAndNumberWithFadeOut();
  }

  private playDektopIntroOutAnim(): void {
    this.introTextSpine.playAnim(SlotAnimationConstant.FG_INTRO_DESKTOP_OUT, false);
    this.freeGameIntroSpine.playAnim(SlotAnimationConstant.FG_INTRO_DESKTOP_BG_OUT, false);
    const fadeInTween = ingenuity.currentGame.add.tween(this.freeGameIntroSpine).to({ alpha: 0 }, 250, Linear.None, true, 0, 0, false);
    fadeInTween.onComplete.addOnce(() => {
      ingenuity.currentGame.tweens.remove(fadeInTween);
      this.freeGameIntroSpine.setPause(true)
      this.freeGameIntroSpine.visible = false
      this.freeGameIntroSpine.alpha = 1
    }, this);
    this.freegameIntroBackgroundLayer.playAnim(spineConstants.FG_INTRO_DESKTOP_LAYER_BG_OUT, false);
    !ingenuity.deviceEnv.isDesktop && this.freegameIntroBackgroundLayer.playAnim(spineConstants.FG_INTRO_LAYER_BG_OUT_PORTRAIT, false);
    this.introTextSpine.onComplete.addOnce(() => {
      this.onIntroSpinEnds();
    })
  }

  protected onIntroContinuePressUp(): void {
    if (!ingenuity.deviceEnv.isDesktop) {
      this.freegameIntroBackgroundLayer.visible = false;
      this.freegameIntroBackgroundLayer.setPause(true);
      this.freeGameIntroPortraitSpine.visible = false;
      this.freeGameIntroPortraitSpine.setPause(true);
      this.freeGameIntroPortraitSpine.onComplete.dispose();
    }
    dispatcher.fireEvent(SlotEventConstantsBehavior.STOP_GAME_SOUND, { id: SoundConstant.BASEGAME_BGMLOOP });
    dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_TOP_GAME_LOGO);
    dispatcher.fireEvent(SlotEventConstants.HIDE_BASEGAME_VIEW);
    dispatcher.fireEvent(SlotEventConstantsBehavior.UNSUBSCRIBE_BASEVIEW_EVENTS);
    dispatcher.fireEvent(SlotEventConstants.SHOW_FREEGAME_VIEW);
    this.resetIntroComponent();
    this.sendFreeGameSpinCall();
  }

  private sendFreeGameSpinCall(): void {
    delayedCall(
      SlotConstantsBehavior.START_FG_SPIN_DELAY,
      SlotConstantsBehavior.DURATION_500,
      () => {
        killDelayedCall(SlotConstantsBehavior.START_FG_SPIN_DELAY);
        dispatcher.fireEvent(SlotEventConstantsBehavior.START_FG_SPIN);
      },
      this
    );
  }

  protected resetIntroComponent(): void {
    delayedCall(
      "IntroResetDelay",
      2000,
      () => {
        killDelayedCall("IntroResetDelay");
        ingenuity.configData.showBaseGameScreen = false;
        this.introTextSpine.visible = false;
        this.freeGameIntroSpine.visible = false;
        this.freegameIntroBackgroundLayer.visible = false;
        this.IntroContainer.visible = false;
        this.IntroContainer.alpha = 1;
      },
      this
    );
  }

  protected onOutroShow(): void {
    super.onOutroShow();
    dispatcher.fireEvent(eventDispatchers.HIDE_STICKY_FRAMES_CONTAINER_FG);
    dispatcher.fireEvent(eventDispatchers.HIDE_STICKY_FRAMES_CONTAINER);
    ingenuity.configData.showLogoBaseGameScreen = false;
    dispatcher.fireEvent(eventDispatchers.HIDE_TOP_LOGO);
    dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_TOP_BAR_ON_TOP);
    
  }
  protected playFreeGameIntroSpine(): void {
    dispatcher.fireEvent(eventDispatchers.HIDE_STICKY_FRAMES_CONTAINER);
    dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_BUTTON_PANEL_ON_TOP);
    this.showTextAndNumberWithFadeIn();
    this.playFgIntroDesktopSpine();
    !ingenuity.deviceEnv.isDesktop && this.playFgIntroPortraitSpine();
  }
  protected playFgOutroDesktopSpine(): void {
    this.fgOutroSpine.setPause(false);
    this.freegameOutroBackgroundLayer.setPause(false);
    this.fgOutroSpine.visible = true;
    this.freegameOutroBackgroundLayer.visible = true;
    this.playOutroBGInSpine();
    this.playFgOutroTextSpine();
    dispatcher.fireEvent(SlotEventConstantsBehavior.CHANGE_BACKGROUND, SlotConstantsBehavior.FREEGAME_OUTRO_BLUR_BG);
  }

  private playOutroBGInSpine(): void {
    this.fgOutroSpine.playAnim(SlotAnimationConstant.FG_INTRO_DESKTOP_BG_IN, false);
    this.freegameOutroBackgroundLayer.playAnim(spineConstants.FG_INTRO_DESKTOP_LAYER_BG_IN, false);
    this.fgOutroSpine.onComplete.addOnce(() => {
      this.playOutroBGLoopSpine();
    }, this);
  }

  protected playFgOutroPortraitSpine(): void {
    super.playFgOutroPortraitSpine();
    this.freegameOutroBackgroundLayerPortrait.setPause(false);
    this.freegameOutroBackgroundLayerPortrait.visible = true;
    this.freegameOutroBackgroundLayerPortrait.playAnim(spineConstants.FG_INTRO_LAYER_BG_IN_PORTRAIT, false);
  }

  protected playFgOutroPortraitTextSpine(): void {
    this.fgOutroPortraitSpine.setPause(false);
    this.fgOutroPortraitSpine.visible = true;
    this.fgOutroPortraitSpine.playAnim(SlotAnimationConstant.FG_OUTRO_PORTRAIT_IN, false);
    this.fgOutroPortraitSpine.onComplete.addOnce(() => {
      this.freegameOutroBackgroundLayerPortrait.playAnim(spineConstants.FG_INTRO_LAYER_BG_STATIC_PORTRAIT, false);
      this.fgOutroPortraitBGSpine.playAnim(SlotAnimationConstant.FG_OUTRO_PORTRAIT_BG_LOOP, true);
      this.fgOutroPortraitSpine.playAnim(SlotAnimationConstant.FG_OUTRO_PORTRAIT_LOOP, true);
    }, this);
  }

  protected onOutroOutSpinEndPortrait(): void {
    this.freegameOutroBackgroundLayerPortrait.playAnim(spineConstants.FG_INTRO_LAYER_BG_OUT_PORTRAIT, false);
    super.onOutroOutSpinEndPortrait()
  }
  private playOutroBGLoopSpine(): void {
    this.fgOutroSpine.playAnim(SlotAnimationConstant.FG_INTRO_DESKTOP_BG_STATIC, true);
    this.freegameOutroBackgroundLayer.playAnim(spineConstants.FG_INTRO_DESKTOP_LAYER_BG_STATIC, false);
  }

  protected playFgOutroTextSpine(): void {
    this.outroTextSpine.setPause(false);
    this.outroTextSpine.alpha = 1;
    this.outroTextSpine.visible = true;
    this.outroTextSpine.playAnim(this.OUTRO_IN_FG, false);
    this.outroTextSpine.onComplete.addOnce(() => {
      this.outroTextSpine.playAnim(this.OUTRO_LOOP_FG, true);
      this.startOutroTickup();
    }, this);
  }

  protected onOutroOutSpinEnd(): void {
    this.playOutroBGOutSpine();
    this.playOutroTextOutSpine();
    !ingenuity.deviceEnv.isDesktop && this.onOutroOutSpinEndPortrait();
  }

  private playOutroBGOutSpine(): void {
    this.fgOutroSpine.playAnim(SlotAnimationConstant.FG_INTRO_DESKTOP_BG_OUT, false);
    this.freegameOutroBackgroundLayer.playAnim(spineConstants.FG_INTRO_DESKTOP_LAYER_BG_OUT, false);
    !ingenuity.deviceEnv.isDesktop && this.freegameOutroBackgroundLayerPortrait.playAnim(spineConstants.FG_INTRO_LAYER_BG_OUT_PORTRAIT, false);
  }

  private playOutroTextOutSpine(): void {
    this.outroTextSpine.playAnim(this.OUTRO_OUT_FG, false);
    const fadeInTween = ingenuity.currentGame.add.tween(this.fgOutroSpine).to({ alpha: 0 }, 250, Linear.None, true, 0, 0, false);
    fadeInTween.onComplete.addOnce(() => {
      ingenuity.currentGame.tweens.remove(fadeInTween);
      this.fgOutroSpine.setPause(true)
      this.fgOutroSpine.visible = false
      this.fgOutroSpine.alpha = 1
    }, this);
  }

  /**
   * add stage click to intro container
   */
  private onStageClick(): void {
    this.continueText.visible = true;
    this.introPopupBG.interactive = true;
    this.introPopupBG.inputEnabled = true;
    this.introPopupBG &&
      this.introPopupBG.events.onInputUp.add((e: any) => {
        this.onContinuePressUP();
        this.offStageClick();
      }, this);
  }

  /**
   * remove stage click sfter click from intro container
   */
  private offStageClick(): void {
    this.introPopupBG.interactive = false;
    this.introPopupBG.inputEnabled = false;
    this.introPopupBG && this.introPopupBG.events.onInputUp.dispose();
    this.continueText.visible = false;
  }

  protected bindHandlers(): void {
    //
  }

  protected unBindHandlers(): void {
    //
  }

  protected playFgIntroDesktopSpine(): void {
    this.playfgIntroBgSpine();
    this.handleFgIntroSounds();
    this.playfgIntroTextSpine();
    dispatcher.fireEvent(SlotEventConstantsBehavior.CHANGE_BACKGROUND, SlotConstantsBehavior.FREEGAME_INTRO_BLUR_BG);
  }

  protected startOutroWinAmountTickup(): void {
    let _a;
    this.OutroWinAmount.setValue(0);
    this.OutroWinAmount.visible = true;
    this.OutroWinAmount.alpha = 1;
    (_a = this.OutroWinAmount) === null || _a === void 0
      ? void 0
      : _a.startTick(this.outroWinAmount, true, false, 3, true, () => {
        this.onStageClickOutro();
      });
  }

  protected showNoWinPopUp(): void {
    this.fgOutroSpineContainer.visible = false;
    this.freeGameCompleteCont.visible = true;
    this.freeGameCompleteCont.alpha = 0;
    const fadeInTween = ingenuity.currentGame.add.tween(this.freeGameCompleteCont).to({ alpha: 1 }, 250, Linear.None, true, 0, 0, false);
    fadeInTween.onComplete.addOnce(() => {
      ingenuity.currentGame.tweens.remove(fadeInTween);
      this.onStageClickOutro();
    }, this);
  }

  /**
   * add stage click to outro container
   */
  private onStageClickOutro(): void {
    this.outroContinueText.visible = true;
    this.outroPopupBG.interactive = true;
    this.outroPopupBG.inputEnabled = true;
    this.outroPopupBG &&
      this.outroPopupBG.events.onInputUp.add((e: any) => {
        if (this.outroWinAmount > 0) {
          this.onOutroContinuePressUp();
        } else {
          this.onOutroContinuePressUpForNoWin();
        }
        this.offStageClickOutro();
      }, this);
  }

  /**
   * remove stage click after click from outro container
   */
  private offStageClickOutro(): void {
    this.outroPopupBG.interactive = false;
    this.outroPopupBG.inputEnabled = false;
    this.outroPopupBG && this.outroPopupBG.events.onInputUp.dispose();
    this.outroContinueText.visible = false;
  }

  // Overrided to blank function
  protected resetOutroContinueButton(): void {
    //
  }

  /**
    * overide to stop outro animation and mask position
    */
  protected hideFgOutroSpine(): void {
    super.hideFgOutroSpine();
    this.freegameOutroBackgroundLayer.setPause(true);
    this.outroTextSpine.visible = false;
    this.outroTextSpine.setPause(true);
    this.outroTextSpine.onComplete.dispose();
  }
  protected hideFgOutroPortraitSpine(): void {
    super.hideFgOutroPortraitSpine();
    this.freegameOutroBackgroundLayerPortrait.setPause(true);
  }

  protected onOutroHide(): void {
    ingenuity.configData.showLogoBaseGameScreen = true;
    dispatcher.fireEvent(eventDispatchers.TOP_LOGO_SHOW_ON_BIG_WIN_FG);
    super.onOutroHide();
  }

}
